import * as React from 'react';
import { PanelRow, PanelCell, Grid, Cell, Icon } from '@teamsnap/teamsnap-ui';
import FormElementHook from './form-element-hook';
import OrgStatusLog from 'components/organization/organization-status-log';

const CreateElement = FormElementHook as new () => FormElementHook;
export interface Props {
  useHookResponse: any;
  organization: any;
}

const OrgEditDisableFields: React.FunctionComponent<Props> = ({ useHookResponse, organization }) => {
  const { register, setValue } = useHookResponse;
  const disableMessages = {
    default_message: `${organization.name} is currently disabled. For questions, please return to your TeamSnap Dashboard and click the “Help & Support” button in the bottom right.`,
    trial_21: `${organization.name} has reached the end of the 21 Day Trial for TeamSnap Club & League. Please reach out to your sales representative or email sales@teamsnap.com with any questions!`,
    billing_overdue: `${organization.name} has been temporarily disabled due to an overdue invoice. Organization Owners can pay system invoices by going to the Billing & Plans below the Account menu in the top right corner of the page, or go to https://go.teamsnap.com/account?view=clubs. For questions, please reach out to accounting@teamsnap.com`,
    custom_message: '',
  };

  if (!organization.disabled) {
    setValue('disabledMessageType', 'default_message');
    setValue('disabledMessageTemplate', disableMessages.default_message);
  }

  return (
    <PanelRow isWithCells={true} mods="Panel-row--header">
      <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
        <h4>Disable</h4>
      </PanelCell>
      <PanelCell mods="u-size9of12">
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12 u-colorWarning">
            <div className="u-spaceBottomMd">
              All staff members will have their access revoked. Upon direct login or access to the org via the dashboard
              they will see the below message.
            </div>
          </Cell>
        </Grid>
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12">
            <CreateElement
              useHookResponse={useHookResponse}
              field="disabled"
              inputRef={register({
                required: false,
              })}
              type="checkbox"
              label="Disable Organization"
              isInline={true}
            />
          </Cell>
        </Grid>
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12 u-padTopMd">
            <CreateElement
              useHookResponse={useHookResponse}
              inputRef={register({
                required: false,
              })}
              type="select"
              field="disabledMessageType"
              label="Disabled Message"
              options={[
                { text: 'Default Message', value: 'default_message' },
                { text: '21 Day Trial', value: 'trial_21' },
                { text: 'Billing Overdue', value: 'billing_overdue' },
                { text: 'Custom Message', value: 'custom_message' },
              ]}
              onChange={(e) => setValue('disabledMessageTemplate', disableMessages[e.target.value])}
            />
          </Cell>
        </Grid>
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12 u-padTopMd">
            <CreateElement
              useHookResponse={useHookResponse}
              inputRef={register({
                required: false,
              })}
              type="textarea"
              field="disabledMessageTemplate"
              labelHidden={true}
            />
          </Cell>
        </Grid>
        <OrgStatusLog items={organization.activityLogs} />
      </PanelCell>
    </PanelRow>
  );
};

export default OrgEditDisableFields;
